import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "code-based-experiences--content-cards"
    }}>{`Code-based Experiences & Content Cards`}</h1>
    <p>{`This document guides you through integrating code-based experiences and content cards in your application.`}</p>
    <h2 {...{
      "id": "api-reference"
    }}>{`API reference`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./api-reference.md"
        }}>{`Code-based Experiences & Content Cards APIs`}</a></li>
    </ul>
    <h2 {...{
      "id": "public-classes-and-enums"
    }}>{`Public Classes and Enums`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/content-card.md"
        }}>{`Class - ContentCard - DEPRECATED`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/proposition.md"
        }}>{`Class - Proposition`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/proposition-item.md"
        }}>{`Class - PropositionItem`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/surface.md"
        }}>{`Class - Surface`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/messaging-edge-event-type.md"
        }}>{`Enum - MessagingEdgeEventType`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/content-card-schema-data.md"
        }}>{`Schema Class - ContentCardSchemaData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/html-content-schema-data.md"
        }}>{`Schema Class - HtmlContentSchemaData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/inapp-schema-data.md"
        }}>{`Schema Class - InAppSchemaData`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./../public-classes/json-content-schema-data.md"
        }}>{`Schema Class - JsonContentSchemaData`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      